/* eslint-disable react/display-name */
const tpl = new Map();

/* Know usage:
    + src/Resources/views/compose/sent_ok.php
*/
tpl.set('multi-select-option', (data) => {
    return (
        `<li>
            <label>
                <input id="multiselect-option-${data.value}" type="checkbox" name="" value="${data.value}" ${data.checked}>
                ${data.title}
            </label>
        </li>`
    );
});

tpl.set('template-dialog', (data) => {
    return (
        `<div aria-hidden="true" ${data.did ? `id="${data.did}"` : ''} role="dialog" tabindex="-1" title="${data.title}">
            ${data.body}
            <div class="ui-dialog-buttonpane">
                ${data.buttons}
            </div>
        </div>`
    );
});

tpl.set('template-dialog-button', (data) => {
    const buttonType = data.isSubmit ? 'submit' : 'button';
    return `<button class="btn btn-${data.type}" type="${buttonType}">${data.title}</button>`;
});

export default function (key) {
    return tpl.has(key) ? tpl.get(key) : null;
}
